module.exports = {"id":"157492","name":"Jorge Valdivia","rating":"78","photo":"./data/images/photos/3/157492.png","club":{"name":"Colo-Colo","logo":"./data/images/clubs/Colo-Colo.png"},"positions":["MOC","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JorgeValdivia0.json
// module id = 2156
// module chunks = 0